<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title v-if="fieldName == 'coRef'">Reinsurer Reference Helplist</v-toolbar-title>
        <v-toolbar-title v-else>Broker Reference Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.riRef }}</td>
                  <td class="text-xs-left">{{ row.item.riRefName }}</td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      coBrkRef: 'coBrkRef',
      headers: [
        { text: 'Reinsurer Reference', value: 'riRef' },
        { text: 'Reinsurer Name', value: 'riRefName' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      labels: {
        riRef: 'Reinsurer Reference',
        riRefName: 'Reinsurer Name'
      },
      filters: {
        riRef: undefined,
        riRefName: undefined
      },
      loading: false,
      selectedCoBrkRef: undefined,
      totalItems: 0,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  created() {
    if (this.prtFrom) {
      this.items = []
    } else {
      this.doInit()
    }
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getCalcRateHelplist
      if (apiURI) {
        this.loading = true
        try {
          this.loading = true
          const expand = {
            fieldName: 'coBrkRef',
            riType: ''
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((ttyRef) => {
                const convertList = {
                  riRef: ttyRef.riRef,
                  riRefName: ttyRef.riRefName
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSelect(data) {
      const coBrkObj = {
        fieldName: this.fieldName,
        riRef: data.riRef,
        riRefName: data.riRefName
      }
      this.$emit('selectCoBrkRef', coBrkObj)
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.calcRate.menu
    }
  },
  props: {
    fieldName: {
      type: String,
      default: ''
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>

<style>
</style>
